import React from 'react'
import { ProfileContextProps } from 'javascripts/components/Profile/types'

const ProfileContext = React.createContext<Partial<ProfileContextProps>>({})

export default ProfileContext
